/**
 * Admin breadcrumb utilities for resolving admin page navigation paths
 * based on user permissions.
 */

/**
 * Ordered list of admin pages with their required permissions.
 * The order determines priority when resolving the admin landing page.
 */
const ADMIN_PAGES = [
  { path: '/users', resource: 'permissions', action: 'manage' },
  { path: '/roles', resource: 'permissions', action: 'manage' },
  { path: '/audit', resource: 'permissions', action: 'manage' },
  { path: '/admin/model-configuration', resource: 'model_config', action: 'view' },
];

/**
 * Resolves the admin landing page based on user permissions.
 * Returns the first admin page the user has access to.
 *
 * @param {function} hasPermission - Permission check function from AuthContext
 *   that takes (resource, action) and returns boolean
 * @returns {string|null} Path to first accessible admin page, or null if none
 */
export const resolveAdminPath = (hasPermission) => {
  for (const page of ADMIN_PAGES) {
    if (hasPermission(page.resource, page.action)) {
      return page.path;
    }
  }
  return null;
};

export default resolveAdminPath;
